<template>
  <div>

    <div>
      <el-carousel indicator-position="outside" height='600px'>
        <el-carousel-item v-for="item in lunboImgs" :key="item.id">
          <img :src="item.imgSrc" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div>
      <div>
        <el-divider></el-divider>
        <h3 style="text-align: center">实验列表</h3>
        <el-divider></el-divider>

      </div>
        <el-row>
          <el-col :span="5"  @click = 'courseHandler(course.id)' v-for = '(course,index) in courseDetail' :key = 'course.id' :offset="1" >
            <el-card body-style="margin-bottom:10px">
              <img :src="course.image" class="image">
              <div style="padding: 14px;">
                <span>{{ course.name }}</span>
                <div class="bottom clearfix">
                  <span class="time">{{ course.description }}</span>
                  <el-button type="text" class="button"  @click = 'courseHandler(course.id)'>查看实验</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

  </div>


</template>


<script>
    export default {

        name: 'Home',
        data() {
            return {
                courseDetail:[],
                categoryId:1,
                lunboImgs: [
                    {
                        id: 1,
                        imgSrc: 'https://hcdn1.luffycity.com/static/frontend/index/banner1(4)_1539945492.0492468.png'
                    },
                    {
                        id: 2,
                        imgSrc: 'https://hcdn1.luffycity.com/static/frontend/index/骑士(1)_1539945488.713867.png'
                    },
                    {
                        id: 3,
                        imgSrc: 'https://hcdn1.luffycity.com/static/frontend/index/banner11_1538122470.2779157.png'
                    },
                    {
                        id: 4,
                        imgSrc: 'https://hcdn1.luffycity.com/static/frontend/index/home-banner4_1535545832.4715614.png'
                    }
                ],
                currentDate: new Date()
            };
        },
        methods:{
            courseHandler(courseId){
                console.log(courseId)
                this.$router.push({
                    path:`/courses/${courseId}/details-introduce`,

                })
            },
            // 获取全部的课程列表
            getCourseList(){
                this.$http.courseList({'class_id':this.$store.getters.getUserInfo.class_id})
                    .then(res=>{
                        if (!res.code) {
                            this.courseDetail = res.data;
                        }
                    })
                    .catch(err=>{
                        console.log(err);
                    })
            },
        },
        created() {
            this.getCourseList();

        }
    };
</script>
<style>
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue